// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReportAlertWidget__Component[data-v-7fdb2582] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.ReportAlertWidget__Component label[data-v-7fdb2582] {\n    background-color: #ffc0c0;\n    border-radius: 3px;\n    padding: 2px 10px;\n    margin: 5px 3px;\n}\n", ""]);
// Exports
module.exports = exports;
